var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article.id)?_c('div',[_c('div',{staticClass:"article-single"},[_c('CArticle',{attrs:{"article":_vm.article}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }